export const getChildrenSelector = (state) => state?.children?.children;
export const findMatchingChildren = (state) => {
  const { uid } = state.auth;
  return state.user.children.filter((child) => child.parent === uid);
};
export const getCallback = (state) => {
  return state?.auth?.callBack || '/';
};
